<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card dark>
        <v-card-title class="mb-0 pb-0">
          <span class="headline mb-0 pb-0 ml-4 mt-3 font-weight-light"
            >Merge into other Location before deleting</span
          >
        </v-card-title>
        <v-card-text class="mt-0 pt-0">
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12>
                <div class="title mb-2">Locations to delete:</div>
                <div
                  v-for="c in selected"
                  :key="c.id"
                  style="color:red; font-size: 17px;"
                >
                  {{ c.name }}
                  <span class="right">ID-{{ c.id }}</span>
                </div>
              </v-flex>
              <v-flex xs12 mt-3 v-if="artworks.length > 0">
                <b>Affected Artworks:</b>
                <div style="color:white; font-size:17px;">
                  <div v-for="a in artworks" :key="a.id">
                    <b>{{ a.accession_number }}</b>
                    - {{ a.name }} - {{ a.title }}
                  </div>
                </div>
              </v-flex>
              <v-flex v-else mt-3>
                <b>NO ARTWORKS HAVE THIS LOCATION AS CURRENT LOCATION</b>
              </v-flex>

              <v-flex xs12 v-if="artworks.length > 0">
                <v-flex>
                  <div class="title mt-4">
                    Select Location to set new Current Location to artworks
                    below:
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="selectedLocation"
                    @change="setLocation2"
                    :items="sorted_locations"
                    item-text="name"
                    item-value="id"
                    label
                  >
                    <template v-slot:item="data">
                      <v-list-tile-content class="py-2">
                        <v-list-tile-title
                          v-html="data.item.name"
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="data.item.artworks"
                          v-html="`Atworks Count: ${data.item.artworks.length}`"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action
                        >ID-{{ data.item.id }}</v-list-tile-action
                      >
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!-- <v-flex xs12 v-if="contact2">
                  <b
                    ><u>{{ contact2.name }}</u></b
                ><span class="right">ID-{{ contact2.id }}</span>-->
                <!-- / {{contact2.first_name}} / {{contact2.last_name}} / {{contact2.company}}</b> -->
                <!-- </v-flex> -->
                <v-flex xs12 v-if="artworks2.length > 0">
                  <b>Current Artworks af this Location:</b>
                  <ul>
                    <li v-for="a in artworks2" :key="a.id">
                      {{ a.accession_number }} / {{ a.name }} / {{ a.title }}
                    </li>
                  </ul>
                </v-flex>
                <v-flex v-else>
                  <b>NO ARTWORKS</b>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="blue" flat @click="dialog = false">Cancel</v-btn>
          <v-btn
            color="red"
            flat
            @click="deleteLocation2"
            v-if="c_user.delete_rights"
            >Delete Location and move its artworks to Selected location</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mt-4 elevation-0">
      <v-card-title>
        <v-layout row my-3 mx-1>
          <span>
            <v-menu
              offset-y
              :close-on-content-click="true"
              class="text-xs-right mx-4 my-0 py-0 align-center"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="black"
                  dark
                  v-on="on"
                  class="text-xs-right mx-0 mt-2 my-0 py-0"
                >
                  <v-icon small>supervisor_account</v-icon>
                </v-btn>
              </template>
              <v-list value="3">
                <v-list-tile
                  v-for="(item, index) in ownerships"
                  :key="index.id"
                  @click="toggleOwnership(item)"
                >
                  <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                  <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
          <span class="text-xs-left mt-2 pt-1 title">
            {{ selectedOwnership.name }}
          </span>
          <v-spacer></v-spacer>
        </v-layout>

        <v-btn
          class="ml-2 mb-0 mt-3"
          small
          v-if="selected.length > 0 && c_user.delete_rights"
          color="red"
          @click="deleteLocations"
          dark
          >Delete Locations</v-btn
        >
        <v-btn
          class="ml-1 mr-5 mb-0 mt-3"
          small
          v-if="selected.length > 0 && c_user.delete_rights"
          color="black"
          @click="resetSelected"
          dark
          >Clear Selection</v-btn
        >

        <v-spacer></v-spacer>

        <!-- <v-btn-toggle v-model="afilter" class="mt-3 ml-2 mr-1">
          <v-btn small flat key="group1" class="px-2" input-value="2" value="2">
            <span> All </span>
          </v-btn>
          <v-btn small flat key="group2" class="px-2" input-value="1" value="1">
            <span> With artworks </span>
          </v-btn>
          <v-btn small flat key="group3" class="px-2" input-value="0" value="0">
            <span> No Artworks </span>
          </v-btn>
        </v-btn-toggle> -->

        <!-- <v-spacer></v-spacer> -->
        <v-text-field
          v-if="this.$store.state.showSearch"
          prepend-inner-icon="search"
          label="Search "
          clearable
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="table_locations_with_artworks"
        :pagination.sync="pagination2"
        :search="search"
        v-model="selected"
        item-key="id"
        must-sort
        rows-per-page-text="Locations per page"
        no-data-text="No Locations loaded from server. Please click Load Locations in Local Storage Management menu."
        no-results-text="No Locations match the criteria."
        class="elevation-0 mx-4"
      >
        <template slot="items" slot-scope="props">
          <!-- <td style="width:20px;">
            <v-checkbox
              primary
              hide-details
              v-model="props.selected"
              @change="save_currently_selected(props.selected,props.item)"
            ></v-checkbox>
          </td> -->
          <tr :class="{ black: props.expanded, 'white--text': props.expanded }">
            <td style="width:15px; padding:0px; margin:0px;">
              <v-checkbox
                color="black"
                primary
                hide-details
                v-model="props.selected"
              ></v-checkbox>
              <!-- @change="save_currently_selected(props.selected,props.item)" -->
            </td>
            <td>
              <router-link
                class="title"
                :class="{
                  black: props.expanded,
                  'white--text': props.expanded
                }"
                :to="{
                  name: 'EditLocation',
                  params: { id: props.item.id, location: props.item },
                  path: `/locations/edit/${props.item.id}`
                }"
              >
                {{ props.item.name }}
              </router-link>
              <!-- <br>{{ props.item.category }} -->
            </td>
            <td>{{ props.item.city }}</td>
            <td>{{ props.item.country_id }}</td>
            <!-- <td class="text-xs-center" style="width:30px;">{{ props.item.accession_number }}</td>-->
            <td class="text-xs-right" style="width:30px;">
              {{ getNoOfArtworksAtLocation(props.item.artworks) }}
              <!-- <td class="text-xs-right"> -->
              <v-btn icon small @click="props.expanded = !props.expanded">
                <!-- <a href="#" @click="props.expanded = !props.expanded" class=""> -->
                <!-- <span>show artworks </span> -->
                <v-icon
                  v-if="!props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_more</v-icon
                >
                <v-icon
                  v-if="props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_less</v-icon
                >
              </v-btn>
              <!-- </a>  -->
              <!-- <v-btn icon small @click="showDeleteDialog(props.item)">
                  <v-icon class="" color="red" small>delete</v-icon>
                </v-btn> -->
              <!-- </h3> -->
              <!-- <v-chip v-for="a in props.item.exhibition_artworks" v-bind:key="a.id" small >{{a.id}}</v-chip> -->
            </td>

            <!-- <td class="text-xs-right">
              <router-link style="padding-left:10px;" :to="{ name: 'EditLocation', params: {id: props.item.id, location: props.item}, path: `/locations/edit/${props.item.id}`}" >
              <v-btn icon><v-icon>edit</v-icon></v-btn>
              </router-link>
            </td> -->
          </tr>
        </template>

        <template v-slot:expand="props">
          <!-- <v-card-title>
            <v-text-field
              v-model="search[props.item.id]"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title> -->
          <!-- :headers="headers_related" -->
          <v-data-table
            must-sort
            class="elevation-0"
            :pagination.sync="pagination_related"
            hide-headers
            :items="location_artworks(props.item.id)"
            :search="search_related"
            v-model="selected_related"
            item-key="id"
            no-data-text="No Artworks at this location."
            no-results-text="No Artworks match the criteria."
          >
            <template slot="items" slot-scope="props_related">
              <tr>
                <td
                  style="text-align:center; vertical-align: text-top; width: 140px; padding: 7px 0 0 10px;"
                >
                  <img
                    @error="imageUrlAlt"
                    v-if="props_related.item.top_photo_id > 0"
                    v-bind:src="
                      `
                      ${$globals.oldserver}/data/artwork/${props_related.item.id}/${props_related.item.top_photo_id}_th_big.jpg`
                    "
                    style="width: 120px; margin:10px;"
                    :class="{
                      redBorder:
                        props_related.item.top_photo.width < 500 ||
                        props_related.item.top_photo.height < 500
                    }"
                  />
                  <img
                    @error="imageUrlAlt"
                    v-else
                    :src="imageUrlAlt"
                    style="width: 120px; margin:10px;"
                  />
                </td>
                <td>
                  <!-- <v-btn style="width:20px; height:20px" round color="red" icon small dense @click="remove_from_selection(props.item.id,props_related.item.id)" hint="Remove From the Selection"> 
                    <v-icon small dense color=white>remove</v-icon>
                  </v-btn> -->
                  <router-link
                    :to="{
                      name: 'EditArtwork',
                      params: {
                        id: props_related.item.id,
                        artwork: props_related.item
                      },
                      path: `/artworks/edit/${props_related.item.id}`
                    }"
                    class="subheading"
                  >
                    {{
                      props_related.item.artist
                        ? props_related.item.artist.name
                        : props_related.item.name
                    }},
                    <strong>{{ props_related.item.title }}</strong>
                    <!-- , {{props_related.item.accession_number}} -->
                  </router-link>

                  <!-- <v-icon class="ml-2" small>edit</v-icon> -->
                </td>
                <td align="right" class="title">
                  {{ props_related.item.accession_number }}
                </td>
                <!-- <td align="right" class="pr-0 mr-0"> 
                  <v-btn round icon small flat @click="remove_from_selection(props.item.id,props_related.item.id)" hint="Remove From the Selection"> 
                    <v-icon small>remove</v-icon> 
                  </v-btn>
                </td> -->
              </tr>
            </template>
          </v-data-table>

          <v-flex
            style="background-color:#292929; color: #eee;"
            class="px-3 py-1 my-0 elevation-0 xs12"
          >
            <h3 class="font-weight-bold subtitle xs12 flex">&nbsp; &nbsp;</h3>
          </v-flex>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no locations.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { serverBus } from '../../main'
import axios from 'axios'
export default {
  data() {
    return {
      selectedOwnership: {},
      ownerships: [],
      filtered: [],
      dialog: false,
      artworks: [],
      artworks2: [],
      location: {},
      selectedLocation: {},
      afilter: '2',
      locations: [],
      search_related: '',
      selected_related: [],
      pagination2: {
        rowsPerPage: 10,
        sortBy: 'name'
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: []
      },
      ta: [],
      selected_tags: [],
      // selected_categories: [],
      // location_categories: [
      //   {id:1, name: 'loan_borrower', color: 'red', position: 2},
      //   {id:3, name: 'loan_contact_person', color: 'blue', position: 1},
      //   {id:7, name: 'loan_insurance_company', color: 'purple', position: 7},
      //   {id:2, name: 'artwork_acquisition_source', color: 'green', position: 3},
      //   {id:4, name: 'registrar', color: 'yellow', position: 4},
      //   {id:5, name: 'staff', color: 'pink', position: 5},
      //   {id:6, name: 'device_acquisition_company', color: 'grey', position: 6},
      //   {id:8, name: 'staff_external', color: 'grey', position: 8},
      //   {id:9, name: 'trustee', color: 'grey', position: 9}
      // ],
      selected: [],
      search: '',
      headers: [
        { text: '', sortable: false, value: '' },
        { text: 'Location', value: 'name', align: 'left' },
        { text: 'City', value: 'city', align: 'left' },
        { text: 'Country', value: 'country_id', align: 'left' },
        {
          text: 'Number of artworks at location',
          value: 'artworks.length',
          align: 'right'
        }
        // { text: '', value:'',align: 'right' }
      ]
    }
  },
  props: ['items'],
  created: function() {
    ;(this.selectedOwnership.id = 2),
      (this.locations = this.$store.state.locations)
    this.ownerships = Object.assign([], this.$store.getters.my_ownerships)
    this.ownerships.unshift({ id: 'all', name: 'All' })
    this.toggleOwnership(
      this.$store.state.filters['locations']
        ? this.$store.state.filters['locations']
        : this.ownerships[0]
    )
    // this.toggleOwnership(this.ownerships[0]);
  },
  methods: {
    getNoOfArtworksAtLocation(as) {
      if (this.selectedOwnership.id != 'all') {
        return as.filter(a => this.selectedOwnership.id == a.ownership).length
      } else {
        return as.length
      }
    },
    toggleOwnership(o) {
      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      this.$store.dispatch('setFilter', { section: 'locations', ownership: o })
      this.selectedOwnership = o
    },
    imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg'
    },
    setLocation2() {
      this.location2 = this.$store.state.locations.find(
        c => c.id === this.selectedLocation
      )
      this.artworks2 = this.$store.state.artworks.filter(
        a => a.artwork_location_id === this.location2.id
      )
    },
    resetSelected() {
      this.selected = []
      this.artworks = []
      this.artworks2 = []
    },
    deleteLocation(c) {
      this.selected = []
      this.selected.push(c)
      this.dialog = true
      this.location = c
      this.artworks = this.$store.state.artworks.filter(
        a => c.id == a.artwork_location_id
      )
    },
    deleteLocations() {
      this.dialog = true
      // this.location = c;
      this.artworks = this.$store.state.artworks.filter(a =>
        this.selected.map(a => a.id).includes(a.artwork_location_id)
      )
    },
    deleteLocation2() {
      if (this.artworks.length > 0) {
        this.artworks.forEach(c => {
          // this.$emit("showSnackbar", "Moving Artwork to a New Location: " + c.title);
          serverBus.$emit(
            'showSnackbar',
            'Moving Artwork: "' +
              c.title +
              '" to a New Location: "' +
              this.selected.name +
              '".',
            'black'
          )
          var artwork_location_log = {}
          artwork_location_log.created_by = this.c_user.id
          artwork_location_log.artwork_id = c.id
          artwork_location_log.old_location = this.selected.id
          artwork_location_log.artwork_location_id = this.selectedLocation
          artwork_location_log.storage = 'in'
          artwork_location_log.copy = 'artwork'
          artwork_location_log.reason = 'Deleting Old location'
          artwork_location_log.note = 'Deleting Old location'
          artwork_location_log.storage_in = new Date().toISOString().substr(0, 10)
          artwork_location_log.change_date = new Date()
            .toISOString()
            .substr(0, 10)
          axios
            .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
              artwork_location_log: artwork_location_log
            })
            .then(response => {
              this.errors = {}
              this.$store.commit('ADD_LOG', response.data)
              this.$store.dispatch('loadLocations')
              this.$store.dispatch('loadArtworks')
              this.showUpload = !this.showUpload
              serverBus.$emit(
                'showSnackbar',
                'Artwork "' +
                  c.title +
                  '" successfully moved to a new location: "' +
                  this.selected.name +
                  '".',
                'green'
              )
              this.selected = []
              this.selectedLocation = {}
              this.artwork_location_log = {
                storage: 'in',
                note: '',
                change_date: '',
                copy: 'artwork',
                shipper: '',
                reason: '',
                artwork_location_id: '',
                artwork_packing_id: ''
              }
            })
            .catch(error => {
              serverBus.$emit(
                'showSnackbar',
                'There was a problem moving Artwork "' +
                  c.title +
                  '" to a new location: "' +
                  this.selected.name +
                  '".',
                'red'
              )
              // console.log(error);
            })
        })
      } else {
        this.selected.forEach(l => {
          this.deleteLocationFromServer(l)
        })
      }
      this.dialog = false
      this.location = ''
      this.artworks = []
      this.artworks2 = []
      this.selected = []
    },
    deleteLocationFromServer(l) {
      l.updated_by = this.c_user.id
      let url = `${this.$globals.apiserver}/artwork_locations/${l.id}.json`
      axios
        .delete(url, l)
        .then(response => {
          // this.$emit('getArtwork')
          serverBus.$emit(
            'showSnackbar',
            `Location ${l.name} deleted.`,
            'rgba(0, 125, 0, 0.8)'
          )
          this.$store.dispatch('loadLocations')
        })
        .catch(error => {
          serverBus.$emit(
            'showSnackbar',
            'Error occuredd while deleting Location.',
            'rgba(125, 0, 0, 0.8)'
          )
          // console.log(error)
        })

    },
    location_artworks(id) {
      var a = this.$store.state.artworks.filter(function(artwork) {
        return artwork.artwork_location_id == id
      })
      return a
    },
    switchSwitch() {
      this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter)
    },
    clearFilters() {
      this.selected_tags = []
      this.selected_tag_categories = []
    },
    clear_selection() {
      this.$store.dispatch('clearCurrentSelection')
      this.selected = []
    },
    select_all() {
      this.selected = this.table_locations
      var temp_selection = Object.assign([], this.$store.state.currentSelection)
      this.table_locations.forEach(a => {
        if (!temp_selection.includes(a)) {
          temp_selection.push(a)
        }
      })
      this.$store.dispatch('saveCurrentSelection', temp_selection)
    },
    save_selection() {
      this.$store.dispatch('clearCurrentSelection')
    },
    save_currently_selected(a, b) {
      setTimeout(
        function() {
          var temp_selection = Object.assign(
            [],
            this.$store.state.currentSelection
          )
          //// console.log(temp_selection)
          if (!a) {
            // console.log('a true')
            if (!temp_selection.includes(b)) {
              // console.log('doesnt include')
              temp_selection.push(b)
            }
          } else {
            // console.log('false')
            var index = temp_selection.indexOf(b)
            // console.log('index = ' + index)
            temp_selection.splice(index, 1)
          }
          this.$store.dispatch('saveCurrentSelection', temp_selection)
        }.bind(this),
        1000
      )
    },
    save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = Object.assign([], this.$store.state.currentSelection)
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b)
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b)
        // console.log('index = ' + index)
        temp_selection.splice(index, 1)
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection)
    },
    save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags)
      this.ta = this.tagged_locations
    }
  },
  computed: {
    // currrent_path() {
    //   return this.$route.params.ownership;
    // },
    // saved_lists() {
    //   return [
    //     { id: 1, title: "list1" },
    //     { id: 2, title: "list2" }
    //   ];
    // },
    // selected_locations() {
    //   return this.$store.state.currentSelection;
    // },
    table_locations_with_artworks() {
      var out = this.$store.state.locations.filter(l => l.disabled != 1)
      out.forEach(
        item => (item.artworks = [...this.location_artworks(item.id)])
      )
      if (this.selectedOwnership.id != 'all') {
        out = out.filter(a =>
          a.artworks.some(ea => ea.ownership == this.selectedOwnership.id)
        )
      }

      // .map(l => {
      //   l.artworks = this.location_artworks(l.id);
      //   return l;
      // });

      // if (this.afilter == '1') {
      //   console.log('1')
      //   return out.filter(l => this.location_artworks(l.id).length > 0)
      // } else if (this.afilter == '0') {
      //   console.log('0')
      //   return out.filter(l => this.location_artworks(l.id).length == 0)
      // } else {
      //   console.log('000')
        return out
      // }
    },
    sorted_locations() {
      const ls = Object.assign([], this.$store.state.locations)
      return ls.sort(function(a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      })
    }
    // table_contacts() {
    //   return this.$store.state.contacts.filter(
    //     c =>
    //       c.category == "artwork_acquisition_source" ||
    //       c.category == "registrar"
    //   );
    //   // }
    // },
    // table_locations() {
    //   if (this.afilter == 1) {
    //     // var cst = this.selected_categories
    //     var a = this.locations.filter(function(location) {
    //       // console.log(location)
    //       return cst.indexOf(location.category) > -1;
    //     });
    //     // console.log(a)
    //     return this.locations.filter(function(location) {
    //       // console.log(cst)
    //       // console.log(cst.indexOf(location.category))
    //       return cst.indexOf(location.category) > -1;
    //     });
    //   } else {
    //     return this.items;
    //   }
    // },
    // tagged_locations() {
    //   var cst = this.$store.state.currentSelectionTags;
    //   return this.table_locations.filter(function(location) {
    //     return location.tags.some(a_tag => cst.indexOf(a_tag.id) > -1);
    //   });
    // },
    // select_categories() {
    //   var stc = this.selected_tag_categories;
    //   var tc = this.tag_categories;
    //   var tags = Object.assign([], this.$store.state.tags);
    //   var out = [];
    //   // console.log(tags)
    //   tags.forEach(tag => {
    //     var a = tc.filter(function(tagc) {
    //       return tagc.id == tag.tag_category_id;
    //     });
    //     // console.log(a[0].color)
    //     tag.color = a[0].color;
    //     out.push(tag);
    //   });
    //   // console.log(out)
    //   return out.filter(function(tag) {
    //     return stc.some(st => tag.tag_category_id == st);
    //   });
    // }
  }
}
</script>

<style scoped>
td {
  height: 80px !important;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/locations/LocationsTable.vue